import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CommunityFilesList from './components/CommunityFilesList';

const { Cell } = ResponsiveGrid;

const SmartBuilding = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="文件檔案管理"
        breadcrumbs={[
          {
            name: '智慧建築專區',
          },
          {
            name: '文件檔案管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CommunityFilesList />
    </Cell>
  </ResponsiveGrid>
);

export default SmartBuilding;
